let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("dSYJ4")]).then(() => parcelRequire('iQ8us'));